var availableCollections;
var availableCollectionsArray;
var availableCollectionsArrayLength = 0;
var availableCollectionsLoadCount = 0;
var jsonOptions = '';
var colorSelectorDataList = document.getElementById('colors-datalist');
var colorSelectorInput = document.getElementById('color');
var currentColorCollections = '';

function loadJSONOptions (collection) {
  if(collection) {
    getColorCollection('/collections/' + collection + '?view=colors');
  }
}

initColorSelector();

function initColorSelector() {  
  if (typeof product_selected_or_first_available_variant_id !== 'undefined') {
    updateColorOptions(product_selected_or_first_available_variant_id);
  } else if (typeof product_id !== 'undefined') {
    updateColorOptions(product_id);
  }
}


function updateColorOptions(variant_id) {
  if(variantColorCollections[variant_id] && variantColorCollections[variant_id].length) {
    availableCollections = variantColorCollections[variant_id];
  } else {
    availableCollections = productColorCollections;
  }
  
  if(availableCollections !== currentColorCollections) {
    currentColorCollections = availableCollections;
    availableCollectionsArray = availableCollections.split('|');
    availableCollectionsLoadCount = 0;
    availableCollectionsArrayLength = availableCollectionsArray.length;
    jsonOptions = '';
    colorSelectorDataList.innerHTML = '';
    clearColor();
    loadJSONOptions(availableCollectionsArray[0]);
  }
}

function createOptions(item) {
  var option = document.createElement('option');
  option.id = item.handle;
  option.value = item.title;
  colorSelectorDataList.appendChild(option);
}

function clearColor() {
  colorSelectorInput.value = '';
  var colorSwatch = document.querySelector('span.color-swatch');
  colorSwatch.style.background = '';
  var colorSwatchLink = document.querySelector('a.color-swatch-link');
  colorSwatchLink.href = '';
}

function getColorCollection(collection_url) {
  var apiURL = collection_url;
  var request = new XMLHttpRequest();
  request.onreadystatechange = function(response) {
    if (request.readyState === 4) {
      if (request.status === 200) {
        jsonOptions = JSON.parse(request.responseText);
        jsonColors = jsonOptions.colors;
        jsonNextPage = jsonOptions.nextpage;
        colorSelectorInput.placeholder = "Search colour";
        jsonColors.forEach(function(item) {
          createOptions(item);
        });
        if(jsonOptions.nextpage !== '') {
          getColorCollection(jsonNextPage);
        } else {
          if(availableCollectionsArrayLength-1 > availableCollectionsLoadCount) {
            availableCollectionsLoadCount++;
            loadJSONOptions(availableCollectionsArray[availableCollectionsLoadCount]);
          }
        }
      } else {
        
      }
    }
  };
  request.open('GET', apiURL, true);
  request.send();
}


//Update Color Swatch
colorSelectorInput.addEventListener('change', (event) => {
  if (document.contains(document.querySelector('.color-selector .errors'))) {
    document.querySelector('.color-selector .errors').remove();
  }
  var selectedProductID = document.querySelector('#colors-datalist option[value="'+event.target.value+'"]').getAttribute('id');
  var apiURL = '/products/' + selectedProductID + '.js';
  var request = new XMLHttpRequest();
  request.onreadystatechange = function(response) {
    if (request.readyState === 4) {
      if (request.status === 200) {
        var colorMeta = JSON.parse(request.responseText);
        var selectedProductImage = colorMeta.featured_image;
        var colorSwatch = document.querySelector('span.color-swatch');
        var colorSwatchLink = document.querySelector('a.color-swatch-link');
        if(selectedProductImage == 'null') {
          colorSwatch.style.backgroundImage = 'none';
          colorSwatchLink.href = '#';
          colorSwatchLink.classList.add('disabled');
        } else {
          colorSwatch.style.background = "url('"+selectedProductImage+"')";
          colorSwatchLink.href = '/products/' + selectedProductID;
          colorSwatchLink.classList.remove('disabled');
        }
      } else {
        
      }
    }
  };
  request.open('GET', apiURL, true);
  request.send();
});


colorSelectorInput.addEventListener('focusin', (event) => {
  clearColor();
});
